import * as React from "react";
import { useContext } from "react";
import { CardContent, CardTitle } from "../../../components/ui/card";
import { Stack } from "../../../components/ui/stack";
import { ClusterInformationDetails } from "./detailsPageComponents";
import { ClusterContext } from "../context";
import { useWorkspaceContextSlug } from "../../../utils/hooks";
import { ApiError } from "../../../apiUtils";
import { InstanceTable } from "./InstanceTable";
import { ClusterSizeChart } from "../Information/charts/ClusterSizeChart";

export const InfrastructureView = (): React.ReactElement => {
  const { clusterId, cluster, loading, error } = useContext(ClusterContext);
  const account = useWorkspaceContextSlug();

  if (error) {
    // TODO: distinguish "not found" from unpexpected errors
    if (error === ApiError.NotFound) {
      return (
        <p>
          Did not find cluster <code>{clusterId}</code> in account{" "}
          <code>{account}</code>.
        </p>
      );
    } else {
      return (
        <p>
          Unexpected error fetching cluster <code>{clusterId}</code> in account{" "}
          <code>{account}</code>.
        </p>
      );
    }
  }
  return (
    <CardContent>
      <Stack spacing={8} className="p-4">
        <ClusterInformationDetails loading={loading} cluster={cluster} />
        <CardTitle>Cluster Size</CardTitle>
        <ClusterSizeChart clusterId={clusterId} />
        {cluster?.scheduler && (
          <InstanceTable
            instances={[cluster.scheduler]}
            loading={loading}
            instanceRole="Scheduler"
          />
        )}
        <InstanceTable
          instances={cluster?.workersExceptUnprovisionable || []}
          loading={loading}
          instanceRole="Worker"
        />
      </Stack>
    </CardContent>
  );
};
